'use client';

import { Button } from '@common/components';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';

import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import { PolicyCard } from '@/components/molecule/PolicyCard';
import { useAuthStore } from '@/stores/AuthStore';

export const RelatedPolicySection = ({ idx }: { idx: string }) => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const [isMoreButtonClicked, setIsMoreButtonClicked] = useState(false);

  const options = isLogin
    ? AuthQueryOptions[
        'get:/wello/v2/auth/policy/policy/{metaPolicyIdIdx}/related'
      ]
    : UnauthQueryOptions[
        'get:/wello/v2/allows/policy/{metaPolicyIdIdx}/related'
      ];

  const { data, isLoading } = useQuery({
    ...options({
      path: {
        metaPolicyIdIdx: idx,
      },
    }),
    select: (data) => data.context?.contents,
    placeholderData: keepPreviousData,
    enabled: isLogin !== undefined,
  });

  const slicedContents = isLoading
    ? new Array(2).fill({})
    : isMoreButtonClicked
      ? data
      : data?.slice(0, 2);

  const totalCount = data?.length ?? 0;

  if (!totalCount) return null;

  return (
    <section className="my-32 mt-40 border-t-4 border-Gray-200 bg-Gray-white px-20 pt-32">
      <h2 className="mb-16 font-600 text-Gray-900 typo-body2">
        놓치지 말고 함께 살펴보세요!
      </h2>
      <ul className="flex flex-col gap-10">
        {slicedContents?.map((content) => (
          <li key={content.id}>
            <PolicyCard
              border
              benefit={content.supportBenefit}
              bookmarkCount={content.wishlistCount}
              commentCount={content.commentCount}
              dday={content.dday}
              endAt={content.expirationDate}
              id={content.id}
              idIdx={content.metaPolicyIdIdx}
              imageUrl={content.agencyLogo}
              isBookmarked={content.wishlistYN}
              isLoading={isLoading}
              name={content.policyName}
              agency={content.agency}
            />
          </li>
        ))}
        {2 < totalCount ? (
          <li>
            <Button
              className="w-full"
              dimensions="H48"
              theme="sub-line"
              onClick={() => {
                setIsMoreButtonClicked((prev) => !prev);
              }}
            >
              {isMoreButtonClicked ? '접기' : '더보기'}
            </Button>
          </li>
        ) : null}
      </ul>
    </section>
  );
};
